import { Grid, Menu, MenuItem, TextField } from '@material-ui/core';
import React, { useCallback, useRef, useState } from 'react';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { List } from 'components/reusable/list';
import { posthog } from 'posthog';
import { setAccountGroups } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { createAccountGroup, deleteAccountGroup } from 'store/sagas/sagas';
import './company-groups.css';
export const CompanyGroups = () => {
    const { state, asyncDispatch, dispatch } = useGlobalState();
    const [isCreateLoading, setIsCreateLoading] = useState(false);
    const [anchor, setAnchor] = useState({ el: null, id: null });
    const nameRef = useRef(null);
    const [name, setName] = useState('');
    const [invalidData, setInvalidData] = useState(false);
    const handleClose = useCallback(() => {
        setTimeout(() => {
            setAnchor({ el: null, id: null });
        }, 0);
    }, []);
    const handleClick = useCallback((event, id) => {
        setAnchor({ el: event.currentTarget, id });
    }, []);
    const updateAccountGroup = (accountGroup, remove = false) => {
        if (state.accountGroups) {
            const newGroups = [...state.accountGroups];
            const idx = state.accountGroups.findIndex((j) => j.id === accountGroup.id);
            if (idx !== -1) {
                if (remove) {
                    newGroups.splice(idx, 1);
                }
                else {
                    newGroups[idx] = accountGroup;
                }
                dispatch(setAccountGroups(newGroups));
            }
        }
    };
    const clearForm = () => {
        if (nameRef.current) {
            nameRef.current.value = '';
        }
        setName('');
    };
    const handleName = useCallback((e) => {
        setName(e.target.value);
        setInvalidData(false);
    }, []);
    const onCreateAccountGroup = () => {
        const environment = 'live';
        setIsCreateLoading(true);
        asyncDispatch(createAccountGroup({
            name,
            environment
        }))
            .then(({ accountGroup }) => {
            setIsCreateLoading(false);
            dispatch(setAccountGroups([accountGroup, ...(state.accountGroups ?? [])]));
            posthog.capture('account_group_created');
            clearForm();
        })
            .catch(() => {
            setIsCreateLoading(false);
        });
    };
    return (React.createElement("div", { className: "full-page" },
        React.createElement("div", { className: "groups-main" },
            React.createElement("h1", { className: "g-page-name" }, "Groups"),
            React.createElement("div", null,
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, inputRef: nameRef, label: "Name", onChange: handleName, required: true, style: { minWidth: 200 } })))),
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                            React.createElement(Grid, { item: true, xs: 3 },
                                React.createElement(ButtonWithLoader, { className: "u-margin-top-large", disabled: !name, isLoading: isCreateLoading, name: "Create Group", onClick: onCreateAccountGroup }))))),
                !!state.accountGroups?.length && (React.createElement(List, { columns: [
                        {
                            name: 'Id',
                            id: 'sid',
                            xs: 4
                        },
                        {
                            name: 'Name',
                            id: 'name',
                            xs: 7
                        },
                        {
                            xs: 1,
                            name: '',
                            isClickable: false,
                            customRenderValue: (item) => {
                                const { id } = item;
                                return (React.createElement("div", { className: "pointer", onClick: (e) => {
                                        handleClick(e, id);
                                    } },
                                    React.createElement("i", { className: "candidates__menu_icon fas fa-ellipsis-v" }),
                                    React.createElement(Menu, { anchorEl: anchor.el, id: String(id), keepMounted: true, onClose: handleClose, open: anchor.id !== null && anchor.id === id },
                                        React.createElement(MenuItem, { onClick: () => {
                                                asyncDispatch(deleteAccountGroup({ accountGroupId: id }))
                                                    .then(() => {
                                                    updateAccountGroup(item, true);
                                                    setTimeout(() => {
                                                        handleClose();
                                                    }, 500);
                                                })
                                                    .catch(console.error);
                                            } }, "Remove"))));
                            }
                        }
                    ], items: state.accountGroups, label: "groups", loading: false, total: state.accountGroups.length }))))));
};
